import React, { useState, useEffect } from "react";
import {
  Tooltip,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Legend,
} from "recharts";
import "react-awesome-lightbox/build/style.css";
import { Card, Container, Row, Col, Spinner } from "react-bootstrap";

import MultiSelect from "react-multi-select-component";
import Select from "react-select";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

/* Styles */
import "../../../../../../styles/app/pages/CampaingPreview.scss";
export const Report3 = ({ props }) => {



  const _rows = props.rows.sort((a, b) => a.no - b.no);
  const [mainKey] = useState("quantity");
  const [mainTask, setMainTask] = useState("");
  const [mainRound, setMainRounds] = useState("1");

  const pos_map = _rows.map((key) => key.pos);
  const pos_unique = [...new Set(pos_map)];
  const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
  const [pos_selected, pos_setSelected] = useState([]);

  const round_map = _rows.map((key) => key.round);
  const round_unique = [...new Set(round_map)];
  const round_options = round_unique.map((key) => ({ label: key, value: key }));
  const [round_selected, round_setSelected] = useState([]);

  const product_map = _rows.map((key) => key.product);
  const product_unique = [...new Set(product_map)];
  const product_options = product_unique.map((key) => ({
    label: key,
    value: key,
  }));
  const [product_selected, product_setSelected] = useState([]);

  const [agent_selected, agent_setSelected] = useState([]);

  const task_map = _rows.map((key) => key.task);
  const task_unique = [...new Set(task_map)];
  const task_options = task_unique.map((key) => ({ label: key, value: key }));
  const [task_selected, task_setSelected] = useState([]);
  const [task_types, tasktypes_setSelected] = useState([]);

  useEffect(() => {
    const pos_map = _rows.map((key) => key.pos);
    const pos_unique = [...new Set(pos_map)];
    const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
    pos_setSelected(pos_options);
    const round_map = _rows.map((key) => key.round);
    const round_unique = [...new Set(round_map)];
    const round_options = round_unique.map((key) => ({
      label: key,
      value: key,
    }));

    round_setSelected(round_options);
    const product_map = _rows.map((key) => key.product);
    const product_unique = [...new Set(product_map)];
    const product_options = product_unique.map((key) => ({
      label: key,
      value: key,
    }));
    product_setSelected(product_options);
    const agent_map = _rows.map((key) => key.agent);
    const agent_unique = [...new Set(agent_map)];
    const agent_options = agent_unique.map((key) => ({
      label: key,
      value: key,
    }));
    agent_setSelected(agent_options);
    const task_map = props.tasks.map((key) => key.name);
    const tasks_types = [
      ...new Set(props.tasks.map((key) => key.input_type).flat()),
    ].reduce((hs, tp) => ({ ...hs, [tp]: true }), {});
    tasktypes_setSelected(tasks_types);
    const task_unique = [...new Set(task_map)];
    const task_options = task_unique.map((key) => ({ label: key, value: key }));
    const [default_task] = task_options;
    default_task && setMainTask(default_task);
    task_setSelected(task_options);
  }, [_rows, props.tasks, props.round]);

  const raw = _rows
    .filter((row) => pos_selected.map((row) => row.value).includes(row.pos))
    .filter((row) => round_selected.map((row) => row.value).includes(row.round))
    .filter((row) =>
      product_selected.map((row) => row.value).includes(row.product)
    )
    .filter((row) =>
      agent_selected.map((row) => row.value).includes(row.agent)
    );

  const data = {};
  for (const row of raw) {
    const key = data[row.pos] ?? {};
    const round = key[row.round] ?? {};
    const product = round[row.product] ?? {};
    const task = product[row.task] ?? {};
    if (task_types["File (photo)"]) {
      task.file = row.file;
      task.image = row.image;
    }
    if (task_types["Rate"]) {
      task.rate = row.rate;
    }
    if (task_types["Comment"]) {
      task.comment = row.comment;
    }
    if (task_types["Yes/No"]) {
      task.yesno = row.yesno;
    }
    if (task_types["Quantity"]) {
      task.quantity = row.quantity;
      task.sku = row.sku ?? 0;
    }
    task.manufacture = row.manufacture;

    product[row.task] = task;
    round[row.product] = product;
    key[row.round] = round;
    data[row.pos] = key;
  }

  return (
    <Card.Body className="p-4 mt-5">
      <Container fluid>
        <Row className="w-100 justify-content-end"></Row>
        <br />
        <div className="card p-2 shadow-sm pb-5 px-4">
          <h4 className="text-muted">Filters Criteria</h4>
          <Row>
            <Col>
              <label>Select POS</label>
              <MultiSelect
                name="pos"
                options={pos_options}
                value={pos_selected}
                onChange={pos_setSelected}
                labelledBy={"Select POS"}
              />
            </Col>
            <Col>
              <label>Select Rounds</label>
              <Select
                defaultValue={round_selected}
                options={round_options}
                onChange={setMainRounds}
              />
            </Col>
            <Col>
              <label>Select Products</label>
              <MultiSelect
                name="product"
                options={product_options}
                value={product_selected}
                onChange={product_setSelected}
                labelledBy={"Select Product"}
              />
            </Col>
            <Col xs={5}>
              <label>Select Tasks</label>
              <Select
                defaultValue={task_selected}
                options={task_options}
                onChange={setMainTask}
              />
            </Col>
          </Row>
        </div>
        <br />

        <br />
        {!props.queryng ? (
          <>
            <div className="layout_grid">

              <div className="layout__data">
                {Object.entries(data).map(([pos, rounds]) => {
                  const products = rounds[mainRound.value] ?? {};

                  return (
                    <>
                      <h2>Location</h2>
                      <h3>{pos}</h3>
                      <h4>Results</h4>
                      <Col xs={10}>
                        <Card className="p-2 mb-2">
                          <Card.Body>
                            <h4 className="strong p-2">
                              Visit {mainRound.value}
                            </h4>
                            <div className="report__table--3">
                              <div className="report__table--products">
                                <strong>
                                  <p>Products</p>
                                </strong>
                                <div className="report__table--products__procontent">
                                  {Object.entries(products).map(
                                    ([product], index) => (
                                      <p key={index}>
                                        #{index + 1}: {product}
                                      </p>
                                    )
                                  )}
                                </div>
                              </div>
                              <div className="report__table--results">
                                <strong>
                                  <p>Results</p>
                                </strong>
                                <div className="report__table--results__resultscon">
                                  {Object.entries(products).map(
                                    ([product, data], index) => (
                                      <p key={index}>
                                        {data[mainTask.value]?.[mainKey] ?? (
                                          <span className="badge badge-danger">
                                            No results
                                          </span>
                                        )}
                                      </p>
                                    )
                                  )}
                                </div>
                              </div>
                              {mainKey === "quantity" && (
                                <div className="report__table__titletotal">
                                  <strong>
                                    <p>Total</p>
                                  </strong>
                                </div>
                              )}
                              {mainKey === "quantity" && (
                                <div className="report__table--total">
                                  <p>
                                    {Number(
                                      Object.values(products)
                                        .reduce(
                                          (ttl, data) =>
                                            ttl +
                                            (data[mainTask.value]?.[mainKey] ??
                                              0),
                                          0
                                        )
                                        .toFixed(2)
                                    )}
                                  </p>
                                </div>
                              )}
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>

                    </>
                  );
                })}
              </div>
              <div className="layout__chart">
                <h1>Grafica de Datos</h1>
                <Col className={12}>
                  <LineChart
                    layout="horizontal"
                    width={500}
                    height={300}
                    data={[...raw]
                      .sort((a, b) => a.round - b.round)
                      .filter((row) => row.task === mainTask.value)
                      .map((row) => ({
                        ...row,
                        round: "Round " + row.round,
                        [`${row.pos}_${row.product}`]: row.quantity,
                      }))}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <YAxis type="number" />
                    <XAxis dataKey="product" type="category" />
                    <Tooltip />
                    <Legend />
                    <Line dataKey="quantity" stroke="#8884d8" />
                  </LineChart>
                </Col>
              </div>
            </div>
          </>
        ) : (
          <div className="mt-2 w-100 d-flex justify-content-center">
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        )}
      </Container>
    </Card.Body>
  );
}
